import { render, staticRenderFns } from "./syncData.vue?vue&type=template&id=b5aa8126"
import script from "./syncData.vue?vue&type=script&lang=js"
export * from "./syncData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports